export default "__VITE_ASSET__CnmqmR6b__"